"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AlgebraVisualization = () => {
    return (react_1.default.createElement("div", { className: "algebra-visualization" },
        react_1.default.createElement("div", { className: "visualization-header" },
            react_1.default.createElement("h1", null, "Algebra Visualization"),
            react_1.default.createElement("p", null, "This section will visualize various algebraic concepts, such as equations and graphs.")),
        react_1.default.createElement("div", { className: "explanation", style: {
                marginTop: '40px',
                padding: '20px',
                background: '#1e293b',
                borderRadius: '8px'
            } },
            react_1.default.createElement("h3", { style: { marginBottom: '15px', color: '#f8fafc' } }, "What am I looking at?"),
            react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0' } }, "This visualization demonstrates fundamental algebraic concepts through interactive graphs and equations. Key concepts include:"),
            react_1.default.createElement("ul", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } },
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Linear equations"),
                    ": Straight line graphs showing relationships between variables"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Quadratic equations"),
                    ": Parabolic curves representing second-degree polynomials"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Polynomial functions"),
                    ": Complex curves showing higher-degree relationships"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Systems of equations"),
                    ": Visualizing solutions where equations intersect")),
            react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } }, "Adjust parameters to see how changes affect the graphs and solutions."))));
};
exports.default = AlgebraVisualization;
